<template lang="html">
  <v-container>
    <form @submit="$event.preventDefault()">
      <v-form ref="form">
        <v-card elevation="2">
          <v-card-title>Login</v-card-title>

          <v-card-text>
            <v-text-field
              v-model="email"
              label="Email"
              required
              type="email"
            ></v-text-field>
            <v-text-field
              v-model="pass"
              label="Password"
              required
              type="password"
            ></v-text-field>
          </v-card-text>

          <v-card-actions>
            <v-btn
              max-width="374"
              elevation="2"
              color="success"
              @click="login"
            >Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </form>
  </v-container>
</template>

<script>
import { AuthAPI } from '@/api';
export default {
  data() {
    return {
      email: '',
      pass: '',
      loading: false,
    };
  },
  methods: {
    login() {
      
      if(!this.$refs['form'].validate()) {
        return;
      }

      this.loading = true;
      AuthAPI.login({
        email: this.email,
        pass: this.pass
      }).then(res => {
        this.$store.commit('user/auth', res.data.auth);
        this.$router.push('/dashboard')
      }).finally(() => {
        this.loading = false;
      });
    },
  }
}
</script>

<style lang="scss" scoped>

.v-container {

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  flex-grow: 1;

  &#content {
    flex-direction: column;
  }
  .header {
    text-align: center;
    margin: 20px 0;
  }
  .v-form {
    max-width: 300px;
  }
}

</style>
